import React from "react";
import { useSelector } from "react-redux";
import { getCertDetails } from "./certReducer";
import { CertTable } from "./certDetailsTable/CertTable";
import { CertParamTypes } from "../types/types";
import { useParams } from "react-router-dom";
import * as cState from "./certReducer";
import { Loading } from "../components/utils/Loading";
import BreadCrumb from "../components/breadcrumbs/BreadCrumb";
import { BreadRoute } from "../components/breadcrumbs/BreadRoute";

export const CertDetails: React.FC = () => {
  const { certOperationId } = useParams<CertParamTypes>();
  const { initLoading } = useSelector(cState.getAllCustomerCerts);
  const data = useSelector((cState) => getCertDetails(cState, certOperationId));
  const headers = ["mailId", "mailTo", "mailState", "mailOperationResult"];
  const crumbs = [
    { label: "certmenu", link: "/certmenu" },
    { label: "certs", link: "/certs" },
    { label: `cert ${certOperationId}`, link: `/certs/${certOperationId}` },
  ];

  return (
    <div className='container w-screen h-full items-center'>
      <BreadRoute>
        {crumbs.map((c, i) => {
          const last = i + 1 === crumbs.length;
          return (
            <BreadCrumb
              key={c.link}
              label={c.label}
              link={c.link}
              lastChild={last}
            />
          );
        })}
      </BreadRoute>
      <div className='container h-full max-h-3/4 w-full flex justify-center items-center overflow-auto scroller'>
        {initLoading ? (
          <Loading />
        ) : (
          <CertTable list={data} headerRow={headers} />
        )}
      </div>
    </div>
  );
};

export default CertDetails;
